// ! NOTE: Add new variables as needed

const variables = {
  isPrimary: false,
};

export default variables;
